module.exports = __webpack_public_path__ + "img/ventus-phone-nobg.ceb95142.png";